import { patchRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function updateOrderTemplateRequest(id, patch) {
	let url = orderTemplates.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}